/*
 * CustomizeOfferSelectorConstants
 */

export const DISPLAY_OFFERS = 'ideal/components/CustomizeOffer/DISPLAY_OFFERS';
export const OFFER_SELECTED = 'ideal/components/CustomizeOffer/OFFER_SELECTED';
export const OFFER_MONTHLY_RATE_CALCULATED =
  'ideal/components/CustomizeOffer/OFFER_MONTHLY_RATE_CALCULATED';
export const FEES_RESET =
  'ideal/components/CustomizeOffer/FEES_RESET';
export const FEES_UPDATE =
  'ideal/components/CustomizeOffer/FEES_UPDATE';
export const SERVICE_SELECTED =
  'ideal/components/CustomizeOffer/SERVICE_SELECTED';
export const ACCESSORIES_CODES_SELECTED =
  'ideal/components/CustomizeOffer/ACCESSORIES_CODES_SELECTED';
export const ACCESSORIES_CODES_COLOR_SELECTED =
  'ideal/components/CustomizeOffer/ACCESSORIES_CODES_COLOR_SELECTED';
export const ACCESSORIES_SELECTED =
  'ideal/components/CustomizeOffer/ACCESSORIES_SELECTED';
export const COLORS_SELECTED =
  'ideal/components/CustomizeOffer/COLORS_SELECTED';
